export const buttonAnimation = {
  duration: 0.5,
  scale: 0,
  autoAlpha: 0,
  ease: 'elastic.out(1, 0.5)',
};
